import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { appStore } from "../../stores/appStore";
import { leagueService } from "../../services/Leagues/LeagueService";
import { BsReceipt } from "react-icons/bs";
import i18n from "../../i18n";
import leaguesData from "../../config.json";
import { StyledMenuButton, StyledMenuOption, StyledMenuSelect } from "./menuStyledComponents"

const Menu = () => {
  const { operatorId, leagueName } = appStore((state) => ({
    operatorId: state.operatorId,
    leagueName: state.leagueName
  }));
  const { t } = useTranslation("General");
  // active menu selection obj
  const MenuIteams = {
    MatchTable: "MatchTable",
    Result: "Result",
    PointsTable: "PointsTable",
    History: "History",
  };
  const navigate = useNavigate();
  const location = useLocation();
  // const [leaguesList, setLeaguesList] = useState([]);
  const [activeLeaguesCount, setactiveLeaguesCount] = useState(0);
  const [activetMenuIteam, setactivetMenuIteam] = useState();
  const [btnDisabled, setBtnDisabled] = useState(true);

  // fetching data from server
  const { setCurrentLeague, setCurrentSeason, currentSeason, currentLeague, betSlipSelections, setShowBetSlip, setLeaguesList, leaguesList } =
    appStore((state) => ({
      setCurrentLeague: state.setCurrentLeague,
      setCurrentSeason: state.setCurrentSeason,
      currentSeason: state.currentSeason,
      currentLeague: state.currentLeague,
      betSlipSelections: state.betSlipSelections,
      setShowBetSlip: state.setShowBetSlip,
      setLeaguesList: state.setLeaguesList,
      leaguesList: state.leaguesList
    }));

  // dynamic select box width
  const refer = useRef(null);
  const helperElement = useRef(null);

  // dynamic resize drap-down width
  useEffect(() => {
    const element = refer.current;
    element.addEventListener("change", initResize);
  }, []);

  const initResize = (event) => {
    const ele = helperElement.current;
    ele.innerHTML = event.target.querySelector("option:checked").innerText;
    resize(ele.offsetWidth);
  };

  const resize = (width) => {
    const root = document.documentElement;
    root.style.setProperty("--dynamic-size", `${width + 20}px`);
  };

  /* fetching leagues list from season backend API  */
  useEffect(() => {
    getLeaguesList();
    // navigate("/matches");
  }, []);

  /* fetching LeaguesList details from backend API */
  const getLeaguesList = async () => {
    const response = await leagueService.getLeaguesList();
    let data = response.data;
    if (data.length > 0) {
      setLeaguesList(data);
      setCurrentLeague(data[0]);
      setCurrentSeason(data[0].currentSeasonNumber);
    } else {
      console.log("Data not found");
    }
  };

  const getLeaguesList2 = async () => {
    const response = await leagueService.getLeaguesList();
    let data = response.data;
    const activeLeagueList = data.filter((isActive) => {
      return isActive.isActive;
    });
    setactiveLeaguesCount(activeLeagueList.length);

    if (data.length > 0) {
      setLeaguesList(data);
      let updatedLeague = data.find(
        (league) => league.leagueId === currentLeague.leagueId
      );
      if (updatedLeague) {
        setCurrentLeague(updatedLeague);
      }
    } else {
      console.log("Data not found");
    }
  };

  useEffect(() => {
    getLeaguesList2();
    // navigate("/matches");
  }, [currentSeason]);

  // based on league Selection changing currentLeague and season
  const onLeagueSelect = ($event) => {
    let filteredLeaguesList = leaguesList.filter(
      (league) => league.leagueId === $event.target.value
    );
    let selectedLeague =
      filteredLeaguesList.length > 0 ? filteredLeaguesList[0] : {};
    setCurrentLeague(selectedLeague);
    setCurrentSeason(selectedLeague.currentSeasonNumber);
  };

  const [gamePath, setGamePath] = useState("")

  window.onhashchange = () => {
    if (gamePath === "/matches/gametable" || gamePath === "/") {
      window.parent.postMessage({ action: "lobby" }, (document.referrer || (window.parent && window.parent.location.href)));
    }
  }

  useEffect(() => {
    setGamePath(location.pathname)
    if (location.pathname === "/") {
      navigate("/matches/gametable")
    }
    if (location.pathname === "/pointstable") {
      setactivetMenuIteam(MenuIteams.PointsTable);
    } else if (location.pathname === "/results") {
      setactivetMenuIteam(MenuIteams.Result);
    } else if (location.pathname === "/bethistory") {
      setactivetMenuIteam(MenuIteams.History);
    } else {
      setactivetMenuIteam(MenuIteams.MatchTable);
    }
  }, [location]);

  const betSlipBtn = () => {
    window.scrollTo(0, 0);
    window.parent.postMessage({ action: "scrolltotop" }, "*");
    setShowBetSlip(true);
  };

  // if betslipSelection is 0 then betslip button disable  
  useEffect(() => {
    setBtnDisabled(betSlipSelections.length === 0 ? true : false);
  }, [betSlipSelections]);

  return (
    <React.Fragment>
      <div className="w-100 px-3">
        <div className="d-flex justify-content-between menu">
          <div className="dropdown d-flex justify-content-between justify-items-center rounded pt-2 fill-full d-flex w-100">
            {activeLeaguesCount === 1 ? (
              <div
                className="bg-white p-1 border fw-bold rounded listbox selectbox resizing-select d-flex align-items-center text-black ps-2"
                onChange={onLeagueSelect}
                ref={refer}
              >

                {
                  leaguesList.map((list, index) => {
                    const leagueDisplayName = leagueName && leagueName?.leaguePrefix ? leagueName.leaguePrefix + list.leagueName.split("-")[1] : list.leagueDisplayName;
                    return (
                      list.isActive === 1 && (
                        <div key={index} value={list.leagueId}>
                          {t(`${leagueDisplayName}`)} ({t("Season")} #{list.currentSeasonNumber})
                        </div>
                      )
                    );
                  })
                }
              </div>
            ) : (
              <StyledMenuSelect
                className="bg-white p-1 border fw-bold rounded listbox selectbox resizing-select d-flex align-items-center text-black ps-2"
                onChange={onLeagueSelect}
                ref={refer}
              >
                {
                  leaguesList.map((list, index) => {
                    const leagueDisplayName = leagueName && leagueName?.leaguePrefix ? leagueName.leaguePrefix + list.leagueName.split("-")[1] : list.leagueDisplayName;

                    return (
                      list.isActive == 1 && (
                        <StyledMenuOption key={index} value={list.leagueId}>
                          {leagueDisplayName} (Season #
                          {list.currentSeasonNumber})
                        </StyledMenuOption>
                      )
                    );
                  })
                }
              </StyledMenuSelect>
            )
            }
            <span
              className="position-absolute start-0 d-none"
              aria-hidden="true"
              ref={helperElement}
            ></span>
          </div>

          <div
            className="btn-group btn-outline-secondary d-flex justify-content-center mt-2 menubuttons"
            role="group"
          >
            <StyledMenuButton selected={activetMenuIteam === MenuIteams.PointsTable}
              className={
                activetMenuIteam === MenuIteams.PointsTable
                  ? "btn c-bg-secondary text-white border-end-0 fw-bold headermenu"
                  : "btn border text-dark border-end-0 bg-white headermenu"
              }
              onClick={(e) => {
                setactivetMenuIteam(MenuIteams.PointsTable);
                navigate("/pointstable");
              }}
            >
              {t("Table")}
            </StyledMenuButton>
            <StyledMenuButton selected={activetMenuIteam === MenuIteams.MatchTable}
              className={
                activetMenuIteam === MenuIteams.MatchTable
                  ? "btn c-bg-secondary border-start-0 border-end-0 fw-bold headermenu text-truncate"
                  : "btn border border-start-0 border-end-0 bg-white headermenu text-truncate"
              }
              onClick={(e) => {
                setactivetMenuIteam(MenuIteams.MatchTable);
                navigate("/matches/gametable");
              }}
            >
              {t("Matches")}
            </StyledMenuButton>
            <StyledMenuButton selected={activetMenuIteam === MenuIteams.Result}
              className={
                activetMenuIteam === MenuIteams.Result
                  ? "btn c-bg-secondary text-white border-start-0 border-end-0  fw-bold headermenu"
                  : "btn border text-dark border-start-0 border-end-0  bg-white headermenu"
              }
              onClick={(e) => {
                setactivetMenuIteam(MenuIteams.Result);
                navigate("/results");
              }}
            >
              {t("Results")}
            </StyledMenuButton>
            <StyledMenuButton selected={activetMenuIteam === MenuIteams.History}
              className={
                activetMenuIteam === MenuIteams.History
                  ? "btn c-bg-secondary text-white border-start-0 fw-bold headermenu text-truncate"
                  : "btn border text-dark border-start-0 bg-white headermenu text-truncate"
              }
              onClick={(e) => {
                setactivetMenuIteam(MenuIteams.History);
                navigate("/bethistory");
              }}
            >
              {t("Bet History")}
            </StyledMenuButton>
          </div>
        </div>
      </div>
      <hr className="mt-3 mb-1" />
    </React.Fragment>
  );
};
export default Menu;
